import { zUid } from "src/types/zUid";
import { z } from "zod";

export const zModeObjectRef = z.enum(["standart", "tag", "link"]);
export type ZModeObjectRef = z.infer<typeof zModeObjectRef>;

export const zModeObjectRefMeta = z.object({
  tagColor: z.string().optional(),
});

export const zObectRef = z.object({
  view: z.literal("ObectRef"),
  mode: zModeObjectRef.optional(),
  modeMeta: zModeObjectRefMeta.optional(),
  labelAtts: zUid.array().optional().nullable(),
});
export type ZObectRef = z.infer<typeof zObectRef>;
